<template>
<div class="small-12 medium-6 large-6 columns">
  <div class="ementaTitle">{{ementa.Restaurante}}</div>
  <div class="table table--2cols">
    <template v-for="(refeicao,inx) in getRefeicoesNotNull(ementa)">
        <div :style="{order: inx+1}"
              class="table-cell firscolumn"
              :class="inx%2 == 0 ? 'isEven' : 'isOdd'">
            {{refeicao.label}}
        </div>
        <div :style="{order: inx+1}"
              class="table-cell secondcolumn"
              :class="inx%2 == 0 ? 'isEven' : 'isOdd'">
            {{ementa[refeicao.value]}}
        </div>
    </template>
  </div>
</div>
</template>

<script>
export default {
  props:["ementa","refeicao", "refeicoes"],
  setup (props) {
  
    const getRefeicoesNotNull = ementa => {
      return props.refeicoes?.filter(el => ementa[el.value] != undefined);
    }

    return {
      getRefeicoesNotNull
    }
  }
}
</script>

<style lang="scss" scoped>
.ementaTitle{
  font-family: 'Montserrat Bold';
  font-size: 22px;
  margin-top: 0px;
  color: #1380a0c7;
  display: contents;
  margin-bottom: 5px;
  padding-top: 40px;
  padding-left: 10px;
}

.table {
  display: flex;
  flex-wrap: wrap;
  margin: 0 0 3em 0;
  padding: 0;
}

.table-cell {
  box-sizing: border-box;
  flex-grow: 1;
  width: 100%;
  padding: 0.8em 1.2em;
  overflow: hidden;
  list-style: none;
}

.table-cell.header{
  font-family: "Montserrat SemiBold";
}

.table--2cols > .table-cell:nth-of-type(2n-1) {
  width: 30%;
}
.table--2cols > .table-cell:nth-of-type(2n) {
  width: 70%;
}

.table-cell.isEven{
  background: rgb(228 228 228 / 68%);
}

.table-cell {
  font-family: "Montserrat";
  color: #494d52;
}

@media (max-width: 767px) {
  .table--2cols > .table-cell:nth-of-type(2n-1) {
    width: 40%;
    padding-left: 7px;
  }

  .table--2cols > .table-cell:nth-of-type(2n) {
    width: 60%;
  }

  .img_ementa {
    width: 50px;
    padding-top: 7px;
  }

  .ementaTitle {
    padding-top: 30px;
    padding-left: 10px;
    font-size: 18px;
  }

  .table-cell {
    font-size: 12px;
  }

  .table-cell {
    padding: 0.55em 1.2em;
  }

  .table {
    margin: 0 0 20px 0;
  }

  .homeEmenta {
    padding-bottom: 55px;
  }
}
</style>